// Example: dd/MM/yyyy HH:mm -> dd/MM/yyyy
export const extractDateFormatFromUserPrefenceDatetimeFormat = (datetimeFormat: string): string =>
  datetimeFormat.split(" ")?.[0];

// Example: dd/MM/yyyy HH:mm -> HH:mm
export const extractTimeFormatFromUserPrefenceDatetimeFormat = (datetimeFormat: string): string | undefined =>
  datetimeFormat.substring(11);
